import React, { FunctionComponent, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import styles from "./NewBroadCastFlow.module.css";
import Dropdown from "../../Components/DropDown/Dropdown";
import CustomInput from "../../Components/MarketingAutomation/CustomInput/CustomInput";
import CustomButton from "../../Components/MarketingAutomation/Button/CustomButton";
import { AiOutlineClose } from "react-icons/ai";
import WhatsappMobileBlank from "../../../src/Assets/Images/whatsapp_mobile_blank.png";
import MessagePreviewShownHere from "../../../src/Assets/Images/messagePreviewShownHere.png";
import DragAndDrop from "../../Components/Dropzone/Dropzone";
import Backdrop from "../../Components/Backdrop/Backdrop";
import BrowseTemplate from "../../Components/MarketingAutomation/BrowseTemplate/BrowseTemplate";
import { motion, AnimatePresence } from "framer-motion";
import BrowseContacts from "../../Components/MarketingAutomation/BrowseContacts/BrowseContacts";
import ToggleButton from "../../Components/ToggleButton/ToggleButton";
import { v4 as uuidv4 } from "uuid";
import DateInput from "../../Components/DateInput/DateInput";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import {
  setBrowseContactBudgetFrom,
  setBrowseContactBudgetTo,
  setBrowseContactFronDate,
  setBrowseContactLeadAssignee,
  setBrowseContactLeadSource,
  setBrowseContactLeadType,
  setBrowseContactProjectName,
  setBrowseContactPropertyType,
  setBrowseContactRequirementType,
  setBrowseContactToDate,
  setBrowseTemplate,
  showSnackbarAction,
} from "../../Redux/actions";
import {
  createCampaign,
  fetchSingleTemplate,
  getexcelFirstRowData,
  manipulateString,
  stringManipulateData,
  testMessageTrigget,
  updateCampaign,
  updateCampaignTime,
} from "../../Services/marketingAutomation";
import {
  requirementTypeBudgetRange,
  salesBudgetRange,
  sS3BaseUrl,
} from "../../Values/constants";
import { Link } from "react-router-dom";
import Loading from "../../Components/Loading/Loading";
import NewLoading from "../../Components/Loading/NewLoading";

type props = {
  user: any;
  onClose?: () => void;
  browseContactData: any;
  // setShowBroadCastFlow1: any;
  // setShowBroadCastFlow2?: any;
  draftData?: any;
  setIsRefersh?: any;
};

const NewBroadCastFlow: FunctionComponent<props> = ({
  user,
  onClose,
  browseContactData,
  // setShowBroadCastFlow1,
  // setShowBroadCastFlow2,
  draftData,
  setIsRefersh,
}) => {
  const dispatcher = useDispatch();
  const mapDataArray = [
    "Project",
    "Property Type",
    "Budget",
    "Lead Source",
    "Lead Type",
    "Lead Assignee",
  ];
  const [load, setLoad] = useState(false);
  const [showBroadCastFlow1, setShowBroadCastFlow1] = useState(true);
  const [showBroadCastFlow2, setShowBroadCastFlow2] = useState(false);
  const [campName, setCampName] = useState("");
  const [templateData, setTemplateData] = useState<any>({});
  const [browseContactDetail, setbrowseContactDetail] = useState<any>({});
  const [totalReciptent, setTotalReciptent] = useState<any>("");
  const [totalExcelReciptent, setExcelTotalReciptent] = useState<any>("");
  const [excelUrl, setExcelUrl] = useState("");
  const [excelContact, setExcelContact] = useState("");
  const [excelUploadFileName, setExcelUploadFileName] = useState("");
  const [manupulatedData, setManupulatedData] = useState("");
  const [scheduleTogelActive, setScheduleTogelActive] = useState(false);
  const [excelFirstRow, setExcelFirstRow] = useState([]);
  const [excelFirstRowFromApi, setExcelFirstRowFromApi] = useState([]);
  const [browseContactInputText, setBrowseContactInputText] = useState<
    string[]
  >([]);
  const [campType, setCampType] = useState("");
  const [excelTemplateHeader, setExcelTemplateHeader] = useState<any[]>([]);
  const [sampleContact, setSampleContact] = useState("");
  const [templateMSG, setTemplateMSG] = useState("");
  const [resWACID, setResWACID] = useState("");

  const [selectedValues, setSelectedValues] = React.useState(
    Array(templateData?.MSG_VAR_COUNT || 0).fill("") // Initialize with empty strings
  );
  const handleDropdownChange = (index: any, value: any) => {
    // Update the specific index in the selectedValues array
    const updatedValues = [...selectedValues];
    updatedValues[index] = value;

    let selectedValue: any = {};

    let selectedValueForDemo: any = {};

    updatedValues.forEach((element: any, index: any) => {
      selectedValue[index + 1] = element?.value;
      selectedValueForDemo[index + 1] = excelFirstRow[0][element?.value]
    });

    const data = manipulateString(
      browseContactData?.selectedBrowseTemplate?.MSG_CONTENT,
      selectedValueForDemo
    );

    setTemplateMSG(data);

    setSelectedValues(updatedValues);
  };

  const handleBrowseContactInputText = async (index: number, value: string) => {
    setBrowseContactInputText((prev) => {
      let selectedValue: any = {};
      const updated = [...prev];
      updated[index] = value; // Update the specific index

      updated.forEach((element: any, index: any) => {
        selectedValue[index + 1] = element;
      });

      const data = manipulateString(
        browseContactData?.selectedBrowseTemplate?.MSG_CONTENT,
        selectedValue
      );
      setTemplateMSG(data);

      return updated;
    });
  };

  const [openBrowseTemplates, setOpenBrowseTemplates] = useState(false);
  const [openBrowseContacts, setOpenBrowseContacts] = useState(false);
  const [templateId, setTemplateId] = useState("");
  //   const [projectName, setProjectName] = useState<any>([]);
  const [placeHolder1, setPlaceHolder1] = useState<any>({
    label: "Select",
    value: "Select",
  });

  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");

  const handleDateChange = (selectedDate: any) => {
    setScheduleDate(selectedDate);
    // updateTimestamp(selectedDate, time);
  };
  const handleTimeChange = (selectedTime: any) => {
    setScheduleTime(selectedTime);
    // updateTimestamp(date, selectedTime);
  };

  const fetchSingleTemp = async (selectedTemplateId: any, templateIdType: string) => {
    const templateRes = await fetchSingleTemplate(selectedTemplateId, templateIdType);
    setTemplateData(templateRes);
    dispatcher(setBrowseTemplate(templateRes));
  };

  function downloadExcelFile(fileUrl: any, fileName = "") {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName; // Suggests a filename for the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  useEffect(() => {
    if (draftData.CAMPAIGN_STATUS === "New") {
      setShowBroadCastFlow1(false);
      setShowBroadCastFlow2(true);
    }
    if (draftData?.CAMPAIGN_TYPE) {
      setCampType(draftData?.CAMPAIGN_TYPE);
    }
    if (draftData?.CAMPAIGN_NAME && draftData?.CAMPAIGN_NAME !== "N/A") {
      setCampName(draftData?.CAMPAIGN_NAME);
    }
    if (draftData?.CAMPAIGN_FILE) {
      setExcelUrl(sS3BaseUrl + draftData?.CAMPAIGN_FILE);
      getexcelFirstRowData(draftData.WACID,(data) => setExcelFirstRow(data),(data) => setExcelFirstRowFromApi(data))
    }
    if (draftData?.WATID) {
      fetchSingleTemp(draftData?.WATID, "WATID");
    }
    if (draftData?.OTID) {
      fetchSingleTemp(draftData?.OTID, "OTID");
    }
    if (draftData?.LEAD_FROM_DATE) {
      const originalDate = new Date(draftData?.LEAD_FROM_DATE);
      const offsetInMilliseconds = (5 * 60 + 30) * 60 * 1000;
      const newDate = new Date(originalDate.getTime() + offsetInMilliseconds);
      const dateOnly = newDate?.toISOString()?.split("T")[0];
      dispatcher(setBrowseContactFronDate(dateOnly));
    }
    if (draftData?.LEAD_TO_DATE) {
      const originalDate = new Date(draftData?.LEAD_TO_DATE);
      const offsetInMilliseconds = (5 * 60 + 30) * 60 * 1000;
      const newDate = new Date(originalDate?.getTime() + offsetInMilliseconds);
      const dateOnly = newDate?.toISOString()?.split("T")[0];
      dispatcher(setBrowseContactToDate(dateOnly));
    }
    if (draftData?.PROJECT_NAME) {
      const parseData = JSON.parse(draftData?.PROJECT_NAME);
      if (parseData?.length === 0 || parseData?.project?.length === 0) {
        dispatcher(setBrowseContactProjectName([]));
      } else {
        const result = parseData?.project?.map((item: any) => ({
          value: item,
          label: item,
        }));
        dispatcher(setBrowseContactProjectName(result));
      }
    }
    if (draftData?.PROPERTY_TYPE) {
      const parseData = JSON.parse(draftData?.PROPERTY_TYPE);
      if (parseData?.length === 0 || parseData?.property_type?.length === 0) {
        dispatcher(setBrowseContactPropertyType([]));
      } else {
        const result = parseData?.property_type?.map((item: any) => ({
          value: item,
          label: item,
        }));
        dispatcher(setBrowseContactPropertyType(result));
      }
    }
    if(draftData?.RQUIREMENT_TYPE){
      const parseData = JSON.parse(draftData?.RQUIREMENT_TYPE);
      if(parseData.requirement_Type[0]){
        dispatcher(setBrowseContactRequirementType({value:parseData.requirement_Type[0],label:parseData.requirement_Type[0]}));
      }

    }
    if (draftData?.BUDGET) {
      const parseData = JSON.parse(draftData?.BUDGET);
      if (parseData?.length === 0 || parseData?.budget?.length === 0) {
        dispatcher(setBrowseContactBudgetTo([]));
        dispatcher(setBrowseContactBudgetFrom([]));
      } else {
        let selectedBudgetFrom
        let selectedBudgetTo
        if(draftData?.RQUIREMENT_TYPE === "RENTAL"){
          selectedBudgetFrom = requirementTypeBudgetRange.find(
            (item: any) => item.value === parseData.budget[0]
          );
           selectedBudgetTo = requirementTypeBudgetRange.find(
            (item: any) => item.value === parseData.budget[1]
          );
        }
        else{
           selectedBudgetFrom = salesBudgetRange.find(
            (item: any) => item.value === parseData.budget[0]
          );
           selectedBudgetTo = salesBudgetRange.find(
            (item: any) => item.value === parseData.budget[1]
          );
        }
        dispatcher(
          setBrowseContactBudgetFrom([
            {
              value: parseData?.budget[0],
              label: selectedBudgetFrom?.label
                ? selectedBudgetFrom?.label
                : "Min",
            },
          ])
        );
        dispatcher(
          setBrowseContactBudgetTo([
            {
              value: parseData?.budget[1],
              label: selectedBudgetTo?.label ? selectedBudgetTo?.label : "Max",
            },
          ])
        );
      }
    }
    if (draftData?.LEAD_SOURCE) {
      const parseData = JSON.parse(draftData?.LEAD_SOURCE);
      if (parseData?.length === 0 || parseData?.lead_source?.length === 0) {
        dispatcher(setBrowseContactLeadSource([]));
      } else {
        const result = parseData?.lead_source?.map((item: any) => ({
          value: item,
          label: item,
        }));
        dispatcher(setBrowseContactLeadSource(result));
      }
    }
    if (draftData?.LEAD_TYPE) {
      const parseData = JSON.parse(draftData?.LEAD_TYPE);
      if (parseData?.length === 0 || parseData?.lead_type?.length === 0) {
        dispatcher(setBrowseContactLeadType([]));
      } else {
        const result = parseData?.lead_type?.map((item: any) => ({
          value: item,
          label: item,
        }));
        dispatcher(setBrowseContactLeadType(result));
      }
    }
    if (draftData?.LEAD_ASSIGNEE) {
      const parseData = JSON.parse(draftData?.LEAD_ASSIGNEE);
      if (
        parseData?.length === 0 ||
        parseData?.contact_owner_email?.length === 0
      ) {
        dispatcher(setBrowseContactLeadAssignee([]));
      } else {
        const result = parseData?.contact_owner_email?.map((item: any) => ({
          value: item,
          label: item,
        }));
        dispatcher(setBrowseContactLeadAssignee(result));
      }
    }
    if (draftData?.SCHEDULE_TYPE === "Scheduled") {
      setScheduleTogelActive(true);
      if (draftData?.SCHEDULED_AT) {
        const dateOnly = draftData.SCHEDULED_AT.split("T")[0];
        setScheduleDate(dateOnly);

        const dateObj = new Date(draftData?.SCHEDULED_AT);

        const offsetInMilliseconds = (5 * 60 + 30) * 60 * 1000;
        const updatedDateObj = new Date(
          dateObj.getTime() + offsetInMilliseconds
        );

        const hours = String(updatedDateObj.getHours()).padStart(2, "0");
        const minutes = String(updatedDateObj.getMinutes()).padStart(2, "0");
        const formattedTime = `${hours}:${minutes}`;
        setScheduleTime(formattedTime);
      }
    }
    if (draftData?.CAMPAIGN_TYPE) {
      if (draftData?.CAMPAIGN_TYPE === "Excel") {
        if (draftData?.LEAD_COUNT) {
          setExcelTotalReciptent(draftData?.LEAD_COUNT);
        }
      } else {
        if (draftData?.LEAD_COUNT) {
          setTotalReciptent(draftData?.LEAD_COUNT);
        }
      }
      if(draftData?.EXTRACTED_HEADERS && draftData?.CAMPAIGN_TYPE === "Excel"){
        const excelHeaders = JSON.parse(draftData.EXTRACTED_HEADERS);
        setExcelTemplateHeader(excelHeaders);
      }
      if (draftData?.PLACEHOLDER_PARAMS) {
        if (draftData?.CAMPAIGN_TYPE === "Excel") {

          const data = draftData?.PLACEHOLDER_PARAMS;

          let formattedData = data.split("~");
          formattedData = formattedData.filter(
            (item: any) => item.trim() !== ""
          );
          // formattedData.shift()

          const result = formattedData.map((item: any) => ({
            value: item === "null" ? "" : item,
            label: item === "null" ? "" : item,
          }));

          if (
            result[0]?.value === "N/A" ||
            result[0] === null ||
            result[0] === "N/A"
          ) {
            setExcelContact("");
          } else {
            setExcelContact(result[0]);
          }
          result.shift();

          setSelectedValues(result);
        } else {
          let formttedDataArray: any = [];
          let formattedData = draftData?.PLACEHOLDER_PARAMS.split("~");
          formattedData.forEach((element: any, index: any) => {
            if (element === "null") {
              formttedDataArray.push("");
            } else {
              formttedDataArray.push(element);
            }
          });
          // formttedDataArray.shift();
          formttedDataArray.pop();
          setBrowseContactInputText(formttedDataArray);
        }
      }
    }
    // }
  }, [draftData]);

  useEffect(() => {
    if (draftData?.PLACEHOLDER_PARAMS) {
      if (draftData?.CAMPAIGN_TYPE === "Excel") {
        const data = draftData?.PLACEHOLDER_PARAMS;

        let formattedData = data.split("~");
        formattedData = formattedData.filter((item: any) => item.trim() !== "");

        const result = formattedData.map((item: any) => ({
          value: item,
          label: item,
        }));

        if (result[0] === "N/A" || result[0] === null) {
          return;
        } else {
          result.shift();
        }

        let selectedValue: any = {};
        let selectedValueForDemo: any = {};
        result.forEach((element: any, index: any) => {
          selectedValue[index + 1] = element.value;
          if(excelFirstRow.length!==0){
          selectedValueForDemo[index + 1] = excelFirstRow[0][element?.value]
          }
        });

        const data1 = manipulateString(
          browseContactData?.selectedBrowseTemplate?.MSG_CONTENT,
          selectedValueForDemo
        );

        setTemplateMSG(data1);
      } else {
        let formattedData = draftData?.PLACEHOLDER_PARAMS.split("~");

        let selectedValue: any = {};
        formattedData.forEach((element: any, index: any) => {
          selectedValue[index + 1] = element;
        });

        const data1 = manipulateString(
          browseContactData?.selectedBrowseTemplate?.MSG_CONTENT,
          selectedValue
        );

        setTemplateMSG(data1);
      }
    }
  }, [browseContactData.selectedBrowseTemplate,excelFirstRowFromApi]);

  const InputWithCrossBrwoseTemplate = () => {
    return (
      <div className={styles.inputContainer}>
        <input
          value={
            templateData?.TEMPLATE_DISP_NAME
              ? templateData?.TEMPLATE_DISP_NAME
              : ""
          }
        />
        {/* <div className={styles.crossVector}></div> */}
        {templateData?.TEMPLATE_DISP_NAME && (
          <div
            className={styles.crossVector}
            onClick={() => {
              setTemplateData({});
              setSelectedValues([]);
              // setCampType("");
              setTemplateMSG("");
              setExcelContact("")
              dispatcher(setBrowseTemplate({}));
            }}
          >
            <AiOutlineClose size={12} color="red" />
          </div>
        )}
      </div>
    );
  };

  const InputWithCrossExcel = () => {
    return (
      <div className={styles.inputContainer}>
        <input
          value={excelUploadFileName ? excelUploadFileName : ""}
          style={{ width: "100%" }}
        />
        {/* <div className={styles.crossVector}></div> */}
        {excelUploadFileName && (
          <div
            className={styles.crossVector}
            onClick={() => {
              setExcelUrl("");
              setSelectedValues([]);
              setCampType("");
              setTemplateMSG("");
              setExcelContact("");
              setTotalReciptent("");
              setExcelTemplateHeader([]);
            }}
          >
            <AiOutlineClose size={12} color="red" />
          </div>
        )}
      </div>
    );
  };

  const InputWithCross = () => {
    return (
      <div className={styles.inputContainer}>
        <input
          value={totalReciptent ? `${totalReciptent} Total Recipient` : ""}
        />
        <div className={styles.crossVector}></div>
        {/* <div className={styles.crossVector}>

            </div> */}
        {totalReciptent && (
          <div
            className={styles.crossVector}
            onClick={() => {
              setExcelUrl("");
              setTotalReciptent("");
              setSelectedValues([]);
              setTemplateMSG("");
              setExcelContact("");
              setCampType("");
            }}
          >
            <AiOutlineClose size={12} color="red" />
          </div>
        )}
      </div>
    );
  };

  const nextButtonClicked = async () => {
    if (campName === "" || campName === undefined) {
      dispatcher(showSnackbarAction("Please Enter Campaign Name", "error"));
      return;
    } else if (
      templateData === undefined ||
      Object.keys(templateData).length === 0
    ) {
      dispatcher(showSnackbarAction("Please Select Message Template", "error"));
      return;
    } else if (
      (totalReciptent === "0" || totalReciptent === "") &&
      excelUrl === ""
    ) {
      dispatcher(
        showSnackbarAction(
          "Please Select Recipient Contact Or Upload Excel",
          "error"
        )
      );
      return;
    } else if (campType === "Excel" && excelContact === "") {
      dispatcher(
        showSnackbarAction("Please Select Contact Number Dropdown", "error")
      );
      return;
    } else {
      setLoad(true);
      const manipulatedString = await stringManipulateData(
        templateData,
        campType === "Contacts" ? browseContactInputText : selectedValues,
        campType
      );
      if (manipulatedString?.success === false) {
        setTimeout(() => {
          setLoad(false);
          dispatcher(
            showSnackbarAction("Please Fill All Values", "error")
          );
          return;
        }, 500);
      } else {
        const camStatus = "Draft";
        if (manipulatedString?.data) {
          if (resWACID === "" && draftData?.WACID === undefined) {
            const createCampaignRes = await createCampaign(
              campName,
              templateData,
              user,
              campType,
              excelUrl,
              browseContactData,
              excelTemplateHeader,
              scheduleTogelActive,
              camStatus,
              campType === "Contacts" ? browseContactInputText : selectedValues,
              scheduleDate,
              scheduleTime,
              totalReciptent === "" || totalReciptent === "0"
                ? totalExcelReciptent
                : totalReciptent,
              excelContact
            );
            if (createCampaignRes.success === true) {
              setTimeout(() => {
                setLoad(false);
              }, 1000);
              setManupulatedData(manipulatedString.data);
              setShowBroadCastFlow2(true);
              setShowBroadCastFlow1(false);
              setResWACID(createCampaignRes.WACID);
            } else {
              setTimeout(() => {
                dispatcher(
                  showSnackbarAction(
                    "Some error occured , please try again",
                    "error"
                  )
                );
                setLoad(false);
                return;
              }, 500);
            }
          } else {
            const createCampaignRes = await updateCampaign(
              campName,
              templateData,
              user,
              campType,
              excelUrl,
              browseContactData,
              excelTemplateHeader,
              scheduleTogelActive,
              camStatus,
              campType === "Contacts" ? browseContactInputText : selectedValues,
              scheduleDate,
              scheduleTime,
              totalReciptent === "" || totalReciptent === "0"
                ? totalExcelReciptent
                : totalReciptent,
              excelContact,
              resWACID === "" ? draftData?.WACID : resWACID
            );
            if (createCampaignRes?.success === true) {
              setTimeout(() => {
                setLoad(false);
              }, 500);
              setManupulatedData(manipulatedString.data);
              setShowBroadCastFlow2(true);
              setShowBroadCastFlow1(false);
            }
            else{
              setTimeout(() => {
                setLoad(false);
                dispatcher(
                  showSnackbarAction("Some error occured. Please try again", "error")
                );
                return;
              }, 500);
            }
          }
        } else {
          setTimeout(() => {
            setLoad(false);
            dispatcher(
              showSnackbarAction("Please Fill All Values", "error")
            );
            return;
          }, 500);
        }
      }
    }
  };

  const draftButtonClicked = async () => {
    const camStatus = "Draft";
    setLoad(true);
    if (draftData?.WACID || resWACID !== "") {
      const createCampaignRes = await updateCampaign(
        campName,
        templateData,
        user,
        campType,
        excelUrl,
        browseContactData,
        excelTemplateHeader,
        scheduleTogelActive,
        camStatus,
        campType === "Contacts" ? browseContactInputText : selectedValues,
        scheduleDate,
        scheduleTime,
        totalReciptent === "" || totalReciptent === "0"
          ? totalExcelReciptent
          : totalReciptent,
        excelContact,
        resWACID === "" ? draftData?.WACID : resWACID
      );
      if (createCampaignRes?.success === true) {
        setTimeout(() => {
          setLoad(false);
          setIsRefersh(true);
          if (onClose) {
            onClose();
          }
          dispatcher(setBrowseContactFronDate(""));
          dispatcher(setBrowseContactToDate(""));
          dispatcher(setBrowseTemplate({}));
          dispatcher(setBrowseContactProjectName([]));
          dispatcher(setBrowseContactPropertyType([]));
          dispatcher(setBrowseContactLeadSource([]));
          dispatcher(setBrowseContactLeadType([]));
          dispatcher(setBrowseContactLeadAssignee([]));
          dispatcher(setBrowseContactRequirementType([]));
          dispatcher(setBrowseContactBudgetTo([]));
          dispatcher(setBrowseContactBudgetFrom([]));
          dispatcher(showSnackbarAction(createCampaignRes?.message, "success"));
          return;
        }, 1000);
      } else {
        setLoad(false);
        dispatcher(
          showSnackbarAction(
            createCampaignRes?.error
              ? createCampaignRes?.error
              : "An error occured",
            "error"
          )
        );
        return;
      }
    } else {
      const createCampaignRes = await createCampaign(
        campName,
        templateData,
        user,
        campType,
        excelUrl,
        browseContactData,
        excelTemplateHeader,
        scheduleTogelActive,
        camStatus,
        campType === "Contacts" ? browseContactInputText : selectedValues,
        scheduleDate,
        scheduleTime,
        totalReciptent === "" || totalReciptent === "0"
          ? totalExcelReciptent
          : totalReciptent,
        excelContact
      );
      if (createCampaignRes?.success === true) {
        setTimeout(() => {
          setLoad(false);
          setIsRefersh(true);
          if (onClose) {
            onClose();
          }
          dispatcher(setBrowseContactFronDate(""));
          dispatcher(setBrowseContactToDate(""));
          dispatcher(setBrowseTemplate({}));
          dispatcher(setBrowseContactProjectName([]));
          dispatcher(setBrowseContactPropertyType([]));
          dispatcher(setBrowseContactLeadSource([]));
          dispatcher(setBrowseContactLeadType([]));
          dispatcher(setBrowseContactLeadAssignee([]));
          dispatcher(setBrowseContactBudgetTo([]));
          dispatcher(setBrowseContactBudgetFrom([]));
          dispatcher(setBrowseContactRequirementType([]));
          // window.location.reload()
          dispatcher(showSnackbarAction(createCampaignRes?.message, "success"));
          return;
        }, 1000);
      } else {
        setLoad(false);
        dispatcher(
          showSnackbarAction(
            createCampaignRes?.error
              ? createCampaignRes?.error
              : "An error occured",
            "error"
          )
        );
        return;
      }
    }
  };

  const scheduleButtonClicked = async () => {
    let parsedDate: any = "";
    let currentDate: any = "";

    if (scheduleTogelActive && scheduleDate && scheduleTime) {
      const [hours, minutes] = scheduleTime.split(":").map(Number);
      const [year, month, day] = scheduleDate.split("-").map(Number);

      // Create the parsed date object
      parsedDate = new Date(year, month - 1, day, hours, minutes);
      currentDate = new Date();

      // Check if parsedDate is in the past
    }
    if (parsedDate < currentDate) {
      dispatcher(
        showSnackbarAction("Cannot schedule for old date and time", "error")
      );
      return;
    } else if (
      scheduleTogelActive === true &&
      (scheduleDate === "" || scheduleTime === "")
    ) {
      dispatcher(showSnackbarAction("Please Select Date And Time", "error"));
      return;
    } else {
      // setLoad(true)
      if (draftData?.CAMPAIGN_STATUS === "New") {
        const updateCampTime = await updateCampaignTime(
          user,
          draftData,
          scheduleTogelActive,
          scheduleDate,
          scheduleTime
        );
        if (updateCampTime?.success === true) {
          // setLoad(false)
          setIsRefersh(true);
          if (onClose) {
            onClose();
          }
          dispatcher(showSnackbarAction(updateCampTime?.message, "success"));
          return;
        } else {
          // setLoad(false)
          dispatcher(
            showSnackbarAction(
              updateCampTime?.error
                ? updateCampTime?.error
                : "An error occured",
              "error"
            )
          );
          return;
        }
      } else if (draftData.CAMPAIGN_STATUS === "Draft") {
        const camStatus = "New";
        const createCampaignRes = await updateCampaign(
          campName,
          templateData,
          user,
          campType,
          excelUrl,
          browseContactData,
          excelTemplateHeader,
          scheduleTogelActive,
          camStatus,
          campType === "Contacts" ? browseContactInputText : selectedValues,
          scheduleDate,
          scheduleTime,
          totalReciptent === "" || totalReciptent === "0"
            ? totalExcelReciptent
            : totalReciptent,
          excelContact,
          draftData?.WACID
        );
        if (createCampaignRes?.success === true) {
          // setLoad(false)
          setIsRefersh(true);
          if (onClose) {
            onClose();
          }
          setIsRefersh(true);
          dispatcher(setBrowseContactFronDate(""));
          dispatcher(setBrowseContactToDate(""));
          dispatcher(setBrowseTemplate({}));
          dispatcher(setBrowseContactProjectName([]));
          dispatcher(setBrowseContactPropertyType([]));
          dispatcher(setBrowseContactLeadSource([]));
          dispatcher(setBrowseContactLeadType([]));
          dispatcher(setBrowseContactLeadAssignee([]));
          dispatcher(setBrowseContactBudgetTo([]));
          dispatcher(setBrowseContactBudgetFrom([]));
          dispatcher(setBrowseContactRequirementType([]));
          dispatcher(showSnackbarAction(createCampaignRes?.message, "success"));
          return;
        } else {
          // setLoad(false)
          dispatcher(
            showSnackbarAction(
              createCampaignRes?.error
                ? createCampaignRes?.error
                : "An error occured",
              "error"
            )
          );
          return;
        }
      } else {
        const camStatus = "New";
        const createCampaignRes = await updateCampaign(
          campName,
          templateData,
          user,
          campType,
          excelUrl,
          browseContactData,
          excelTemplateHeader,
          scheduleTogelActive,
          camStatus,
          campType === "Contacts" ? browseContactInputText : selectedValues,
          scheduleDate,
          scheduleTime,
          totalReciptent === "" || totalReciptent === "0"
            ? totalExcelReciptent
            : totalReciptent,
          excelContact,
          resWACID
        );
        if (createCampaignRes?.success === true) {
          // setLoad(false)
          dispatcher(showSnackbarAction(createCampaignRes?.message, "success"));
          dispatcher(setBrowseContactFronDate(""));
          dispatcher(setBrowseContactToDate(""));
          dispatcher(setBrowseTemplate({}));
          dispatcher(setBrowseContactProjectName([]));
          dispatcher(setBrowseContactPropertyType([]));
          dispatcher(setBrowseContactLeadSource([]));
          dispatcher(setBrowseContactLeadType([]));
          dispatcher(setBrowseContactLeadAssignee([]));
          dispatcher(setBrowseContactBudgetTo([]));
          dispatcher(setBrowseContactBudgetFrom([]));
          dispatcher(setBrowseContactRequirementType([]));
          setIsRefersh(true);
          if (onClose) {
            onClose();
          }
          // window.location.reload()
          dispatcher(showSnackbarAction(createCampaignRes?.message, "success"));
          return;
        } else {
          // setLoad(false)
          dispatcher(
            showSnackbarAction(
              createCampaignRes?.error
                ? createCampaignRes?.error
                : "An error occured",
              "error"
            )
          );
          return;
        }
      }
    }
  };

  const closeButtonClicked = () => {
    setIsRefersh(true);
    if (onClose) {
      onClose();
    }
    dispatcher(setBrowseContactFronDate(""));
    dispatcher(setBrowseContactToDate(""));
    dispatcher(setBrowseTemplate({}));
    dispatcher(setBrowseContactProjectName([]));
    dispatcher(setBrowseContactPropertyType([]));
    dispatcher(setBrowseContactLeadSource([]));
    dispatcher(setBrowseContactLeadType([]));
    dispatcher(setBrowseContactLeadAssignee([]));
    dispatcher(setBrowseContactBudgetTo([]));
    dispatcher(setBrowseContactBudgetFrom([]));
    dispatcher(setBrowseContactRequirementType([]));
    // setCampName("")
  };

  const sendMessageButtonClicked = async () => {
    if (sampleContact.length === 10) {
      const res = await testMessageTrigget(
        sampleContact,
        templateData,
        campType,
        campType === "Contacts" ? browseContactInputText : selectedValues,
        excelFirstRow,
        user,
        resWACID,
        draftData
      );
      if (res?.success === true) {
        dispatcher(showSnackbarAction(res?.message, "success"));
        return;
      } else {
        if(res?.message){
          dispatcher(showSnackbarAction(res?.message?res?.message:"Some error occured", "error"));
          return; 
        }
        else if(res?.error){
          dispatcher(showSnackbarAction(res?.error?res?.error:"Some error occured", "error"));
          return; 
        }
      }
    } else {
      dispatcher(
        showSnackbarAction("Please enter valid mobile number", "error")
      );
      return;
    }
  };

  const dropIn = {
    hidden: {
      y: "-100vh",
      opacity: 1,
    },
    visible: {
      y: "0",
      opacity: 1,
      transition: {
        duration: 1,
        type: "spring",
        damping: 25,
        stiffness: 500,
      },
    },
  };

  useEffect(() => {
    let excleName: any;
    if (excelUrl) {
      const parsedUrl = new URL(excelUrl);
      // Split the pathname by '/' and get the last element
      excleName = parsedUrl.pathname.split("/").pop();
    }
    setExcelUploadFileName(excleName);
  }, [excelUrl]);

  return (
    <Backdrop>
      {load === true && <NewLoading />}
      <motion.div
        key="modal"
        className="card shadow rounded"
        style={{
          position: "absolute",
          width: "fit-content",
          minWidth: "800px",
          height: "600px",
          // overflowY: "scroll",
          borderRadius: "0.75rem",
          border: "solid 1px #d2cece",
          backgroundColor: "#fff",
          // ...containerStyles
        }}
        variants={dropIn}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <div style={{ display: "flex", overflowY: "scroll" }}>
          <div style={{ width: "60%" }}>
            {showBroadCastFlow1 && (
              <div className={styles.leftContainer}>
                <div>
                  <span className={styles.newBroadcast}>New Broadcast</span>
                  {/* <BasicTextField /> */}
                  <div style={{ marginTop: "1rem" }}>
                    {/* <CustomInput
                      type="text"
                      placeholder="Campaign name"
                      value={campName}
                      onChange={setCampName}
                    /> */}
                    <Box
                      component="form"
                      sx={{ "& > :not(style)": { m: 0, width: "100%" } }}
                      noValidate
                      autoComplete="off"
                    >
                      <TextField
                        id="outlined-basic"
                        label="Campaign name"
                        variant="outlined"
                        value={campName}
                        onChange={(e) => setCampName(e.target.value)}
                      />
                    </Box>
                  </div>
                </div>

                <div>
                  <span className={styles.selectTemplateTitle}>
                    Select Message Template
                  </span>
                  <div className={styles.selectTemplateContainer}>
                    <InputWithCrossBrwoseTemplate />
                    <CustomButton
                      text="Browse Templates"
                      onClick={() => {
                        setOpenBrowseTemplates(true);
                        setOpenBrowseContacts(false);
                      }}
                      buttonType="secondary"
                    />
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span className={styles.selectTemplateTitle}>
                      Recipient Contacts
                    </span>
                    {templateData?.TEMPLATE_DISP_NAME && (
                      <span className={styles.downloadSample}>
                        <div
                          onClick={() => {
                            if (templateData?.TEMPLATE_DISP_NAME) {
                              const fileUrl = `https://read-pro.s3.ap-south-1.amazonaws.com/templats/${templateData?.PH_HEADERS_FILE}`;
                              if (templateData?.PH_HEADERS_FILE) {
                                const fileName = "sample-file.csv";
                                downloadExcelFile(fileUrl, fileName);
                              } else {
                                dispatcher(
                                  showSnackbarAction("No sample file", "error")
                                );
                                return;
                              }
                            } else {
                              dispatcher(
                                showSnackbarAction(
                                  "Please select a template",
                                  "error"
                                )
                              );
                              return;
                            }
                          }}
                          className={styles.hyperlinkStyle}
                        >
                          Download sample file
                        </div>
                      </span>
                    )}
                  </div>
                  {excelUrl === "" && (
                    <div style={{ marginTop: "1rem" }}>
                      <div className={styles.selectTemplateContainer}>
                        <InputWithCross />
                        <CustomButton
                          text="Browse Contacts"
                          onClick={() => {
                            setLoad(true);
                            setOpenBrowseContacts(true);
                            setOpenBrowseTemplates(false);
                            setTimeout(() => {
                              setLoad(false);
                            }, 1200);
                          }}
                          buttonType="secondary"
                          // disable={browseContact?true:false}
                        />
                      </div>
                    </div>
                  )}

                  {excelUrl === "" &&
                    (totalReciptent === "0" || totalReciptent === "") && (
                      <p className={styles.textStyle1}>or</p>
                    )}

                  {(totalReciptent === "0" || totalReciptent === "") && (
                    <>
                      <div style={{ marginTop: "1rem" }}>
                        {excelUrl === "" ? (
                          <DragAndDrop
                            setExcelUrl={setExcelUrl}
                            setExcelTemplateHeader={setExcelTemplateHeader}
                            // setBrowseContact={setBrowseContact}
                            setCampType={setCampType}
                            user={user}
                            setExcelTotalReciptent={setExcelTotalReciptent}
                            setExcelFirstRow={setExcelFirstRow}
                          />
                        ) : (
                          <InputWithCrossExcel />
                        )}
                      </div>
                    </>
                  )}
                </div>
                {/* {projectName.length === 0 && ( */}
                <>
                  {templateData?.MSG_VAR_COUNT &&
                    (totalReciptent !== "" || excelUrl !== "") && (
                      <div>
                        {/* {templateData?.MSG_VAR_COUNT &&   */}
                        <span className={styles.selectTemplateTitle}>
                          Map data from uploaded contacts
                        </span>
                        {/* } */}

                        <div
                          style={{
                            marginTop: "1rem",
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.5rem",
                          }}
                        >
                          {Array.from({
                            length: templateData?.MSG_VAR_COUNT || 0,
                          }).map((_, index) => (
                            <div
                              key={index}
                              className={styles.dropdownContainer}
                            >
                              <span className={styles.selectTemplateTitle}>
                                V{index + 1}
                              </span>
                              {excelUrl !== "" && (
                                <Dropdown
                                  option={
                                    totalReciptent === "0" ||
                                    totalReciptent === ""
                                      ? excelTemplateHeader
                                      : mapDataArray
                                  }
                                  selectedValue={
                                    selectedValues[index]
                                      ? selectedValues[index]
                                      : []
                                  }
                                  setSelectedValue={(value) => {
                                    handleDropdownChange(index, value);
                                  }}
                                />
                              )}
                              {totalReciptent !== "" && (
                                <CustomInput
                                  type="text"
                                  placeholder="Enter Value"
                                  value={browseContactInputText[index] || ""}
                                  onChange={(value) =>
                                    handleBrowseContactInputText(index, value)
                                  } // Make sure this is defined
                                />
                              )}
                            </div>
                          ))}
                          {excelUrl !== "" &&
                            (totalReciptent === "0" ||
                              totalReciptent === "") && (
                              <div className={styles.dropdownContainer}>
                                <span className={styles.selectTemplateTitle}>
                                  Buyer Contact Number
                                </span>
                                <Dropdown
                                  option={excelTemplateHeader}
                                  selectedValue={excelContact}
                                  setSelectedValue={(value) => {
                                    setExcelContact(value);
                                  }}
                                />
                              </div>
                            )}
                        </div>
                      </div>
                    )}
                </>
                {/* )} */}
              </div>
            )}
            {showBroadCastFlow2 && (
              <div className={styles.leftContainer}>
                <div>
                  <span className={styles.newBroadcast}>New Broadcast</span>
                  {/* <BasicTextField /> */}
                  {/* <TextField id="campaign-name" label="Campaign name" variant="standard" fullWidth /> */}
                </div>

                <div>
                  <span className={styles.selectTemplateTitle}>
                    Confirm Details
                  </span>
                  <div className={styles.confirmDetailsContainer}>
                    <div className={styles.detailDiv}>
                      <p className={styles.detailText1}>Campaign Name</p>
                      <p className={styles.detailText2}>{campName}</p>
                    </div>
                    {excelUrl && (
                      <div className={styles.detailDiv}>
                        <p className={styles.detailText1}>File Name</p>
                        <p className={styles.detailText2}>
                          {excelUploadFileName}
                        </p>
                      </div>
                    )}
                    <div className={styles.detailDiv}>
                      <p className={styles.detailText1}>Total Recipients</p>
                      <p className={styles.detailText2}>
                        {totalReciptent === ""
                          ? totalExcelReciptent
                          : totalReciptent}
                      </p>
                    </div>
                    <div className={styles.detailDiv}>
                      <p className={styles.detailText1}>Variables</p>
                      {campType === "Excel" ? (
                        <p className={styles.detailText2}>
                          {selectedValues.map((item) => item.value).join(", ")}
                        </p>
                      ) : (
                        <p className={styles.detailText2}>
                          {browseContactInputText.join(", ")}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div>
                  <div className={styles.dropdownContainer}>
                    <span className={styles.selectTemplateTitle}>
                      Test with a sample message
                    </span>
                    <div style={{ display: "flex", gap: "0.5rem" }}>
                      {/* <InputWithCross /> */}
                      {/* <CustomInput
                        type="number"
                        prefix="+91"
                        placeholder="Enter number"
                        value={sampleContact}
                        onChange={setSampleContact}
                      /> */}
                      <div className={styles.customInputContainer}>
                        <span
                          style={{
                            marginRight: "0.5rem",
                            color: "#303030",
                            fontSize: "0.9rem",
                          }}
                        >
                          {"+91"}
                        </span>
                        <input
                          type="number"
                          placeholder="Enter number"
                          value={sampleContact}
                          onChange={(e) => {
                            const cleanedValue = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            );
                            setSampleContact(cleanedValue);
                          }}
                          style={{
                            flex: 1,
                            border: "none",
                            outline: "none",
                            fontSize: "0.9rem",
                          }}
                          min={0}
                        />
                      </div>
                      <CustomButton
                        text="Send Message"
                        onClick={sendMessageButtonClicked}
                        buttonType="primary"
                      />
                    </div>
                  </div>
                  <div
                    className={styles.dropdownContainer}
                    style={{ marginTop: "1rem" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span className={styles.selectTemplateTitle}>
                        Schedule
                      </span>
                      <ToggleButton
                        checked={scheduleTogelActive}
                        onChange={() => {
                          setScheduleTogelActive(!scheduleTogelActive);
                        }}
                        id={uuidv4()}
                        customStyles={{
                          backgroundColor: scheduleTogelActive
                            ? "#269f9f"
                            : "#e8e8e8",
                          border: scheduleTogelActive
                            ? "none"
                            : "2px solid #d7d7d7",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        marginTop: "0.5rem",
                      }}
                    >
                      <DateInput
                        mode="date"
                        onChange={handleDateChange}
                        value={scheduleDate}
                        dateDisabled={!scheduleTogelActive}
                      />
                      <DateInput
                        mode="time"
                        onChange={handleTimeChange}
                        value={scheduleTime}
                        dateDisabled={!scheduleTogelActive}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* <div className={styles.rightContainer}>
     <div className={styles.closeIcon}>
       <AiOutlineClose size={24} onClick={onClose} />
     </div>
     <img
       className={styles.whatsappPreviewBlankImg}
       src={WhatsappMobileBlank}
       alt="whatsapp-preview-blank"
     />
     <div className={styles.messagePreviewContainer}>
       <img
         src={MessagePreviewShownHere}
         alt="message-preview-shown-here"
       />
     </div>
     <div className={styles.buttonsContainer}>
       <CustomButton
         text="Save As Draft"
         onClick={() => {}}
         buttonType="secondary"
       />
       <CustomButton
         text="Next"
         onClick={() => {
           setShowBroadCastFlow2(true);
           setShowBroadCastFlow1(false);
         }}
         buttonType="inactive"
       />
     </div>
   </div> */}
          {showBroadCastFlow1 && (
            <div className={styles.rightContainer}>
              <div className={styles.closeIcon}>
                <AiOutlineClose size={24} onClick={closeButtonClicked} />
              </div>
              <div className={styles.whatsappPreviewWrapper}>
                <img
                  className={styles.whatsappPreviewBlankImg}
                  src={WhatsappMobileBlank}
                  alt="whatsapp-preview-blank"
                />
                {templateData?.MSG_CONTENT ? (
                  <div className={styles.textOverlay}>
                    <p
                      dangerouslySetInnerHTML={{
                        __html:
                          templateMSG === ""
                            ? templateData?.MSG_CONTENT?.replace(/\n/, "<br>")
                            : templateMSG?.replace(/\n/, "<br>"),
                      }}
                    />
                    <div className={styles.TemplateFooter}>
                      <Link to={"#"} className={styles.ScheduledTime}>
                        Confirm Scheduled Timings
                      </Link>
                    </div>
                  </div>
                ) : (
                  <div className={styles.messagePreviewContainer}>
                    <img
                      src={MessagePreviewShownHere}
                      alt="message-preview-shown-here"
                    />
                  </div>
                )}
              </div>
              <div className={styles.buttonsContainer}>
                <CustomButton
                  text="Save As Draft"
                  onClick={draftButtonClicked}
                  buttonType="secondary"
                />
                <CustomButton
                  text="Next"
                  onClick={nextButtonClicked}
                  buttonType="primary"
                />
              </div>
            </div>
          )}
          {showBroadCastFlow2 && (
            <div className={styles.rightContainer}>
              {/* <h1>Right</h1> */}
              <div className={styles.closeIcon}>
                <AiOutlineClose size={24} onClick={closeButtonClicked} />
              </div>
              <img
                className={styles.whatsappPreviewBlankImg}
                src={WhatsappMobileBlank}
                alt="whatsapp-preview-blank"
              />
              {manupulatedData ? (
                <div className={styles.textOverlay1}>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: templateMSG?.replace(/\n/, "<br>"),
                    }}
                  />
                  {/* <button className={styles.confirmButton}>Confirm Scheduled Timings</button> */}
                </div>
              ) : (
                <div className={styles.messagePreviewContainer}>
                  <img
                    src={MessagePreviewShownHere}
                    alt="message-preview-shown-here"
                  />
                </div>
              )}
              {/* <div className={styles.messagePreviewContainer}>
                <img
                  src={MessagePreviewShownHere}
                  alt="message-preview-shown-here"
                />
              </div> */}
              <div className={styles.buttonsContainer}>
                <CustomButton
                  text="Back"
                  onClick={() => {
                    setShowBroadCastFlow1(true);
                    setShowBroadCastFlow2(false);
                  }}
                  buttonType="secondary"
                  buttonDisable={
                    draftData.CAMPAIGN_STATUS === "New" ? true : false
                  }
                />
                <CustomButton
                  text="Schedule"
                  onClick={scheduleButtonClicked}
                  buttonType="primary"
                  buttonDisable={false}
                />
              </div>
            </div>
          )}
        </div>
      </motion.div>
      {openBrowseTemplates && (
        <BrowseTemplate
          open={openBrowseTemplates}
          close={() => {
            setOpenBrowseTemplates(false);
          }}
          setExcelTemplateHeader={setExcelTemplateHeader}
          setTemplateData={setTemplateData}
          setBrowseContactInputText={setBrowseContactInputText}
          setSelectedValues={setSelectedValues}
          setTemplateMSG={setTemplateMSG}
          setExcelContact={setExcelContact}
        />
      )}
      {openBrowseContacts && (
        <BrowseContacts
          open={openBrowseContacts}
          close={() => {
            setOpenBrowseContacts(false);
          }}
          setbrowseContactDetail={(value) => {
            setbrowseContactDetail(value);
          }}
          camType={setCampType}
          setTotalReciptent={setTotalReciptent}
          browseContactDetail={browseContactDetail}
        />
      )}
    </Backdrop>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    browseContactData: state.browseContactData,
  };
};

export default connect(mapStateToProps)(NewBroadCastFlow);